var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaxingCrescentMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-9.53674e-07 48.025C3.82956 49.6327 8.00057 50.2745 12.1408 49.8929C16.2811 49.5114 20.2617 48.1184 23.7276 45.8384C27.1935 43.5583 30.0368 40.4621 32.0037 36.826C33.9706 33.1899 35 29.127 35 25C35 20.873 33.9706 16.8101 32.0037 13.174C30.0368 9.5379 27.1935 6.44167 23.7276 4.16162C20.2617 1.88157 16.2811 0.488615 12.1408 0.107072C8.00057 -0.274471 3.82956 0.367263 -9.53674e-07 1.97501C4.55866 3.88884 8.44816 7.09338 11.1827 11.1884C13.9172 15.2833 15.3756 20.0872 15.3756 25C15.3756 29.9128 13.9172 34.7167 11.1827 38.8116C8.44816 42.9066 4.55866 46.1112 -9.53674e-07 48.025Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaxingCrescentMoonIcon);
export default __webpack_public_path__ + "static/media/WaxingCrescentMoonIcon.efff6b5c79082e3956c6ad09b74082d0.svg";
export { ForwardRef as ReactComponent };